import * as React from "react";
import { IParagraphHelloRewardsBannerProps } from "./ParagraphHelloRewardsBannerProps";
import { Container } from "./ParagraphHelloRewardsBannerHelpers";
import { graphql } from "gatsby";
import HelloRewardsBanner from "../../common/HelloRewardsBanner/HelloRewardsBanner";

const ParagraphHelloRewardsBanner: React.FC<
  IParagraphHelloRewardsBannerProps
> = (props) => {
  return (
    <Container>
      <HelloRewardsBanner {...props.node} />
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphHelloRewardsBanner on paragraph__hello_rewards_banner {
    id
    field_description
    field_learn_more_link {
      title
      url
    }
    field_link {
      title
      url
    }
    field_title
    relationships {
      field_teaser_image {
        relationships {
          field_media_image {
            publicUrl
            gatsbyImage(
              width: 640
              height: 480
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
      field_media {
        relationships {
          field_media_file {
            publicUrl
            gatsbyImage(
              width: 640
              height: 480
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
    }
    field_background_color {
      color
    }
  }
`;
export default ParagraphHelloRewardsBanner;
